import React, { useState } from 'react';
import { useParams } from 'react-router';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
// import CopyToClipboardButton from '../../../components/Button/CopyToClipboardButton';
// import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { Modal } from '../../../components/Modal/Modal';
import ExitDispatcherModal from '../../../components/Modal/ModalActions/ExitDispatcherModal/ExitDispatcherModal';
import { DriverDetailsDataType } from '../../../hooks/dashboard/driver-list/useDriverDetails';

interface DriverBioAreaProps {
  data: DriverDetailsDataType;
}

const DriverBioArea: React.FC<DriverBioAreaProps> = ({ data }) => {
  const {
    driverId,
    name,
    // rating,
    profilePicture,
    //  employmentType, timeSpent
  } = useParams();
  const [showModal, setShowModal] = useState(false);

  const averageRating = Number(data?.averageRating);
  const timeAtCompany = Number(data?.timeAtCompany);

  const safeAverageRating = Number.isFinite(averageRating) ? averageRating : 0;
  const averageRatingText = Number.isFinite(averageRating)
    ? `${averageRating}`
    : '--';
  const timeAtCompanyText = Number.isFinite(timeAtCompany)
    ? `${timeAtCompany} years`
    : '--';
  const addressText = data?.address?.trim() || '--';

  return (
    <Container>
      <Img
        src={profilePicture ?? '/static/img/profilePlaceholderLargePlain.png'}
      />
      <TextArea>
        <FirstTextRow>
          <BoldText>
            {data?.firstName} {data?.lastName}
          </BoldText>
          {data?.employmentType ? (
            <StatusCell
              data={{ status: data?.employmentType }}
              statusKey='status'
              customClasses='small-border-radius'
            />
          ) : (
            <LoadingOutlined style={{ fontSize: 16, color: '#999' }} />
          )}
        </FirstTextRow>

        <SecondTextRow>
          <span>Driver</span>
          <VerticalLine></VerticalLine>
          <AddressText>{addressText}</AddressText>
        </SecondTextRow>

        <ThirdTextRow>
          <ThirdTextRowGroup>
            <Stars numStars={safeAverageRating} />
            <BoldNumberText>
              {averageRatingText} ({data?.totalNumberOfRatings || 0})
            </BoldNumberText>
          </ThirdTextRowGroup>

          <VerticalLine></VerticalLine>

          <ThirdTextRowGroup>
            <div>Average Timeline:</div>
            <BoldNumberText>{timeAtCompanyText}</BoldNumberText>
          </ThirdTextRowGroup>

          <VerticalLine></VerticalLine>

          <ThirdTextRowGroup>
            <div>Status:</div>
            {data?.employmentStatus ? (
              <StatusCell
                data={{ status: data?.employmentStatus }}
                statusKey='status'
                customClasses='small-border-radius'
              />
            ) : (
              <LoadingOutlined style={{ fontSize: 16, color: '#999' }} />
            )}
          </ThirdTextRowGroup>
        </ThirdTextRow>
      </TextArea>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <ExitDispatcherModal
          data={{ driverId: driverId ?? '', name: name ?? '' }}
        />
      </Modal>
    </Container>
  );
};

export default DriverBioArea;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  gap: 16px;
  max-width: 827px;
  border-radius: 5px;

  gap: 24px;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  /* border: 1px solid red; */
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  /* border: 1px solid transparent; */
  /* & > * {
    border: 1px solid transparent !important;
  } */
  /* border: none; */
`;

const BoldText = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const FirstTextRow = styled.div`
  display: flex;
  gap: 12px;
`;

const SecondTextRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
`;

const AddressText = styled.span`
  line-height: 1.4;
`;

const ThirdTextRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 27px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const ThirdTextRowGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 11px;
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;

const BoldNumberText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
`;
